import { Button, InputLabel, Stack } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { DialogWindow } from "./DialogWindow";
import { FormTextField } from "UI/FormTextField";

/** @type {import("types/commonTypes").NewProviderData}*/
const defaultFormData = {
  name: "",
  speciality: "",
};

export const AddNewProviderDialog = ({
  open,
  handleClose,
  organizationId,
  setResultValue,
  setError,
}) => {
  const [isCreating, setIsCreating] = useState(false);

  const {
    control,
    handleSubmit,
    getValues,
    reset,
  } = useForm({
    defaultValues: defaultFormData,
  });

  const forceCloseAndReset = () => {
    reset(defaultFormData);
    handleClose();
  };

  const onSubmit = async () => {
    setIsCreating(true);
    const provider = getValues();
    const body = {
      provider: {
        ...provider,
        organizationId,
      },
    };

    body.provider.name = body.provider.name.trim();
    body.provider.speciality = body.provider.speciality.trim();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/providers`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        }
      );
      const result = await response.json();
      if (result?.error || result?.message) {
        setError(result?.error || result?.message);
        setIsCreating(false);
        return;
      }
      if (result?.provider) {
        setResultValue(result?.provider);
        forceCloseAndReset();
        return;
      }
      setError("Failed to create new provider");
    } catch (error) {
      console.error(error);
      setError(error?.message ?? "Failed to create new provider");
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <DialogWindow
      open={open}
      withCloseButton
      handleClose={handleClose}
      title={"Add New Provider"}
      content={
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack mt={2} gap={2} width={"90vw"} maxWidth={"480px"}>
            <Stack direction={"column"} gap={2}>
              <Stack alignItems={"flex-start"}>
                <InputLabel htmlFor="name">Name</InputLabel>
                <FormTextField
                  id="name"
                  name="name"
                  control={control}
                  rules={{ required: "is required" }}
                  InputProps={{
                    autoComplete: "off",
                  }}
                />
              </Stack>
              <Stack alignItems={"flex-start"}>
                <InputLabel htmlFor="speciality">
                  Speciality (optional)
                </InputLabel>
                <FormTextField
                  id="speciality"
                  name="speciality"
                  control={control}
                  InputProps={{
                    autoComplete: "off",
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
        </form>
      }
      actions={
        <Stack
          direction={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100%"}
          gap={2}
          mt={6}
          mb={2}
        >
          <Button
            disabled={isCreating}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Add New Provider
          </Button>
        </Stack>
      }
    />
  );
};
